import {css} from 'lit';
import {tablet} from '../../js/services/const';

export default css`
  :host {
    /* custom ios-like-toggle-element */
    --switch-height: 30px;
    --switch-width: 50px;
    --switch-handle-size: 20px;
  }

  figure img {
    width: 100%;
    height: auto;
  }
  .button, button, select, input, textarea {
    font-size: 1.6rem;
    line-height: 3.8rem;
    border-radius: 0.4rem;
    border: 0.1rem solid transparent;
    font-family: var(--font-family-sans-serif);
    padding: 0 1.6rem;
    box-sizing: border-box;
    display: block;
    float: left;
    margin: 0 1.6rem 1.6rem 0;
    height: 4rem;
  }
  input, textarea, select {
    padding: 0 0.8rem;
    outline: none;
    border-radius: 0.4rem;
    color: var(--text-highVisibility);
  }
  input:focus, textarea:focus, select:focus {
    outline: none;
  }

  select::-moz-focus-inner {
    border: 0;
  }
  input[type='text'], input[type='email'], input[type='password'], input[type='search'], input[type='time'], input[type='date'], input[type='number'], textarea {
    color: var(--text-highVisibility);
    box-shadow: none;
    padding: 0 0.8rem;
    background-color: var(--form-default-background);
    border: 0.1rem solid var(--form-element-default-border);
    box-sizing: border-box;
    line-height: 2rem;
  }
  input[type='text']:hover:enabled, input[type='text']:focus:enabled, input[type='email']:hover:enabled, input[type='email']:focus:enabled, input[type='password']:hover:enabled, input[type='password']:focus:enabled, input[type='search']:hover:enabled, input[type='search']:focus:enabled, input[type='time']:hover:enabled, input[type='time']:focus:enabled, input[type='date']:hover:enabled, input[type='date']:focus:enabled, input[type='number']:hover:enabled, input[type='number']:focus:enabled, textarea:hover:enabled, textarea:focus:enabled {
    border-color: var(--form-element-hover-focus-border);
  }
  input[type='text']::-ms-clear, input[type='email']::-ms-clear, input[type='password']::-ms-clear, input[type='search']::-ms-clear, input[type='time']::-ms-clear, input[type='date']::-ms-clear, input[type='number']::-ms-clear, textarea::-ms-clear {
    display: none;
  }
  input[type='text']:disabled, input[type='email']:disabled, input[type='password']:disabled, input[type='search']:disabled, input[type='time']:disabled, input[type='date']:disabled, input[type='number']:disabled, textarea:disabled {
    color: var(--disabled-color);
    border-color: var(--disabled-color);
  }
  select {
    box-shadow: none;
    padding: 0 0 0 0.8rem;
    border: 0.1rem solid var(--form-element-default-border);
    border-radius: 0.4rem;
    color: var(--cp-grey-light-1);
    background-color: var(--form-default-background);
  }
  select:hover:enabled, select:focus:enabled {
    border-color: var(--element-hover-color);
  }
  input[type='text'] {
    line-height: 2rem;
  }
  textarea {
    padding-top: 1.1rem;
    line-height: 2.4rem;
  }

  .button, button {
    font-weight: 700;
    text-align: center;
    box-shadow: none;
    cursor: pointer;
    outline: none;
    background-color: transparent;
    color: var(--buttonTertiary-default-label);
    border-color: var(--buttonTertiary-default-border);
  }
  .button:hover, button:hover {
    color: var(--buttonTertiary-hover-label);
    background-color: var(--buttonTertiary-hover-background) !important;
    border-color: var(--buttonTertiary-hover-background);
  }
  .button:active, button:active {
    color: var(--buttonTertiary-active-label);
    background-color: var(--buttonTertiary-active-background) !important;
    border-color: var(--buttonTertiary-active-background);
  }
  .button:disabled, .button.disabled, button:disabled, button.disabled {
    background-color: transparent !important;
    color: var(--buttonTertiary-disabled-label);
    border-color: var(--buttonTertiary-disabled-border);
    cursor: default;
  }
  .button.primary, button.primary {
    background-color: var(--button-primary-default-background);
    color: var(--button-primary-default-label) !important;
    border-color: var(--button-primary-default-background);
  }
  .button.primary:hover, button.primary:hover {
    background-color: var(--button-primary-hover-background) !important;
    border-color: var(--button-primary-hover-background);
  }
  .button.primary:active, button.primary:active {
    background-color: var(--button-primary-default-background) !important;
    color: var(--button-primary-default-label);
    border-color: var(--button-primary-default-background);
  }
  .button.primary:disabled, .button.primary.disabled, button.primary:disabled, button.primary.disabled {
    background-color: var(--button-primary-disabled-background) !important;
    color: var(--button-primary-disabled-label) !important;
    border-color: var(--button-primary-disabled-background);
  }
  .button.secondary, button.secondary {
    background-color: transparent;
    color: var(--button-secondary-default-background);
    border-color: var(--button-secondary-default-background);
    font-weight: 400;
  }
  .button.secondary:hover, button.secondary:hover {
    background-color: var(--button-secondary-hover-background) !important;
    color: var(--white);
    border-color: var(--button-secondary-hover-background);
  }
  .button.secondary:active, button.secondary:active {
    background-color: var(--button-secondary-default-background) !important;
    color: var(--white);
  }
  .button.secondary:disabled, .button.secondary.disabled, button.secondary:disabled, button.secondary.disabled {
    background-color: transparent !important;
    color: var(--button-secondary-disabled-label);
    border-color: var(--button-secondary-disabled-border);
  }
  .button-center {
    text-align: center;
    clear: both;
  }
  .button-center .button {
    float: none;
    display: inline-block;
    height: auto;
    line-height: 2.2rem;
    padding: 0.8rem 1.6rem;
    text-decoration: none;
  }
  .button-center .button:hover {
    background-color: var(--brand);
  }
  .button-center .button.button-icon {
    padding: 0.8rem 1.6rem 0.8rem 2.8rem;
  }
  .button-right {
    text-align: center;
    clear: both;
  }
  @media (min-width: ${tablet}px) {
    .button-right {
      text-align: right;
  }
  }
  .button-right .button {
    float: none;
    display: inline-block;
    height: auto;
    margin: 0;
    text-decoration: none;
  }
  .button-right .button:hover {
    background: var(--brand);
  }

  .err-hint {
    display: none;
    font-family: var(--font-family-sans-serif);
    font-size: 1.4rem;
    color: var(--notification-error);
    clear: both;
    padding: 0 0 0.8rem 0;
  }

  form .error {
    border-color: var(--notification-error);
  }
  form .error.err-hint {
    display: block;
  }

  .custom-radio + label {
    line-height: 3rem;
  }
  .custom-radio + label:before {
    border-radius: 50%;
  }
  .custom-radio:enabled:checked + label:before {
    box-shadow: 0 0 0 0.1rem var(--element-hover-color);
  }
  .custom-radio:enabled.error + label:before {
    box-shadow: 0 0 0 0.1rem var(--notification-error);
  }
  .custom-radio:enabled.error:checked + label:before {
    background: var(--notification-error);
  }
  .custom-radio {
    opacity: 0;
    width: 0;
    height: 0;
    margin: 0;
    position: absolute;
    left: -9999px;
  }
  .custom-radio + label {
    float: none;
    display: inline-block;
    position: relative;
    margin-bottom: 1.6rem;
  }
  .custom-radio + label:before {
    content: '';
    box-sizing: border-box;
    height: 3rem;
    width: 3rem;
    margin-right: 1rem;
    float: left;
    border: 0.65rem solid var(--white);
    box-shadow: 0 0 0 0.1rem #ccc;
  }
  .custom-radio:enabled:checked + label:before {
    background: var(--element-hover-color);
  }
  .custom-radio:enabled:focus + label:before, .custom-radio:enabled:hover + label:before {
    box-shadow: 0 0 0 0.1rem var(--element-hover-color);
  }
  .custom-radio:enabled:focus:checked + label:before, .custom-radio:enabled:hover:checked + label:before {
    background: var(--element-hover-color);
  }
  .custom-radio:disabled + label {
    color: var(--disabled-color);
  }
  .custom-radio:disabled + label:before {
    box-shadow: 0 0 0 0.1rem var(--disabled-color);
  }
  .custom-radio:disabled:checked + label:before {
    background: var(--disabled-color);
  }

  label {
    float: left;
    line-height: 3.8rem;
  }

  .clearBoth {
    clear: both;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: var(--switch-width);
    height: var(--switch-height);
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
    -webkit-tap-highlight-color: transparent;
  }

  /* The slider */
  .toggle {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 2px solid;
    border-color: var(--separator-default);
    background-color: white;
    border-radius: 100px;
  }
  .animate .toggle {
    transition: transform 0.4s, background-color 0.4s;
  }
  .toggle .ball {
    position: absolute;
    content: '';
    width: var(--switch-handle-size);
    height: var(--switch-handle-size);
    left: 2px;
    bottom: 1px;
    border: 2px solid;
    border-color: #fff;
    background-color: var(--button-secondary-default-background);
    opacity: 0.15;
    border-radius: 50%;
  }

  .animate .toggle .ball {
    transition: transform 0.4s, background-color 0.4s;
  }

  input:disabled + .toggle {
    background-color: var(--cp-grey-light-6);
    cursor: default;
  }

  input:checked + .toggle .ball {
    background-color: var(--notification-success);
    opacity: 1;
    transform: translateX(calc(var(--switch-width) - var(--switch-handle-size) - 10px)) rotate(45deg);
  }

  input:checked + .toggle .ball:before {
    content: "";
    position: absolute;
    width: 2px;
    height: 12px;
    background-color: var(--form-default-background);
    left: 11px;
    top: 3px;
  }

  input:checked + .toggle .ball:after {
    content: "";
    position: absolute;
    width: 7px;
    height: 2px;
    background-color: var(--form-default-background);
    left: 6px;
    top: 14px;
  }
`;
